/* Rince — scroll-reveal observer. Pairs with rince-motion.css.
   Adds `.rx-in` to reveal targets as they enter the viewport, with a small
   stagger for grid siblings. Sets window.__rxArmed so the inline head script
   skips its safety fallback.
   Robustness: besides the IntersectionObserver, it does an immediate
   rect-based pass (so above-the-fold content reveals without waiting on the
   observer's first callback) and a throttled scroll fallback — so reveals
   work even in environments where IO's initial callback is delayed.
   Extra's: [data-countup] telt het leidende getal in een element op (NL-
   notatie, breedte gereserveerd tegen CLS); in de thema-editor wordt niets
   verborgen en her-laden secties reveal-en direct. */
(function () {
  var SEL = [
    '.hx-eyebrow', '.hx-section-title', '.hx-section-intro',
    '.hx-glass-card', '.hx-persona-quote', '.hx-feature-title', '.hx-feature-num',
    '.hx-life-tile-content', '.hx-essay-frame', '.hx-trust-item', '.hx-faq-item',
    '.rince-tt__header', '[data-reveal]'
  ].join(',');
  var STAGGER = '.hx-glass-card,.hx-persona-quote,.hx-feature-title,.hx-feature-num,.hx-life-tile-content,.hx-essay-frame,.hx-trust-item,.hx-faq-item,[data-reveal]';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  if (reduce || designMode) { root.classList.add('rx-fallback'); window.__rxArmed = true; return; }

  var io = null, pending = [];

  function stagger(els) {
    var seen = [], counts = [];
    els.forEach(function (el) {
      if (!el.matches(STAGGER)) return;
      var p = el.parentElement; if (!p || p.children.length < 2) return;
      var k = seen.indexOf(p);
      if (k === -1) { k = seen.push(p) - 1; counts[k] = 0; }
      el.style.setProperty('--rx-delay', Math.min(counts[k]++, 6) * 75 + 'ms');
    });
  }

  /* [data-countup] — telt het leidende getal op van 0 → eindwaarde.
     Ondersteunt "127", "4,5", "100 dagen", "± 3 mnd". NL-formattering. */
  function countUp(el) {
    if (el.__rxCounted) return; el.__rxCounted = true;
    var text = el.textContent;
    var m = text.match(/^([^0-9]*)([0-9]+(?:[.,][0-9]+)?)([\s\S]*)$/);
    if (!m) return;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var decimals = (numStr.match(/[.,](\d+)/) || [, ''])[1].length;
    var target = parseFloat(numStr.replace(',', '.'));
    if (!isFinite(target) || target === 0) return;
    el.style.minWidth = el.offsetWidth + 'px'; // reserve breedte: geen CLS
    var t0 = null, DUR = 900;
    function fmt(v) {
      var s = v.toFixed(decimals);
      return s.replace('.', ',');
    }
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(frame);
      else { el.textContent = text; el.style.minWidth = ''; }
    }
    requestAnimationFrame(frame);
  }

  function reveal(el) {
    el.classList.add('rx-in');
    if (el.hasAttribute('data-countup')) countUp(el);
    else { var c = el.querySelector('[data-countup]'); if (c) countUp(c); }
  }

  function watch(els) {
    stagger(els);
    els.forEach(function (el) { if (pending.indexOf(el) === -1) pending.push(el); });
    if (io) els.forEach(function (el) { io.observe(el); });
    sweep();
  }

  function sweep() {
    var vh = window.innerHeight || root.clientHeight || 800;
    for (var i = pending.length - 1; i >= 0; i--) {
      var r = pending[i].getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > 0) { reveal(pending[i]); pending.splice(i, 1); }
    }
  }

  function init() {
    if (window.__rxArmed) return;
    window.__rxArmed = true;

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target);
            var ix = pending.indexOf(e.target); if (ix > -1) pending.splice(ix, 1); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }

    watch(Array.prototype.slice.call(document.querySelectorAll(SEL)));

    var ticking = false;
    function onScroll() { if (ticking) return; ticking = true;
      setTimeout(function () { ticking = false; sweep(); }, 90); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if (pending.length) setTimeout(sweep, 200);  // one delayed pass for late layout

    // Thema-editor: her-geladen of verplaatste secties nooit verborgen laten.
    ['shopify:section:load', 'shopify:section:reorder'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var scope = (e.target && e.target.querySelectorAll) ? e.target : document;
        var els = Array.prototype.slice.call(scope.querySelectorAll(SEL));
        els.forEach(function (el) { el.classList.add('rx-in'); });
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
